<p-toast></p-toast>

<div class="page-header">
  <div>
    <h1 class="title">{{ 'AUDIT.TITLE' | translate }}</h1>
    <p class="sub">{{ 'AUDIT.SUBTITLE' | translate }}</p>
  </div>
</div>

<div class="filters-section">
  <div class="filters">
    <input
      pInputText
      [(ngModel)]="filter.user"
      placeholder="بحث عن مستخدم أو username..."
      (keyup.enter)="applyFilters()"
      styleClass="filter-input"
    />
    <p-dropdown
      [options]="[
        { label: 'الكل', value: '' },
        { label: 'نجح', value: 'true' },
        { label: 'فشل', value: 'false' }
      ]"
      [(ngModel)]="filter.succeeded"
      placeholder="النتيجة"
      styleClass="filter-dropdown"
    ></p-dropdown>
    <p-calendar
      [(ngModel)]="filter.from"
      showIcon
      placeholder="من تاريخ"
      [showTime]="true"
      dateFormat="yy-mm-dd"
      styleClass="filter-calendar"
    ></p-calendar>
    <p-calendar
      [(ngModel)]="filter.to"
      showIcon
      placeholder="إلى تاريخ"
      [showTime]="true"
      dateFormat="yy-mm-dd"
      styleClass="filter-calendar"
    ></p-calendar>
    <button pButton icon="pi pi-search" label="بحث" (click)="applyFilters()"></button>
    <button
      pButton
      icon="pi pi-filter-slash"
      label="مسح"
      class="p-button-secondary"
      (click)="clearFilters()"
    ></button>
  </div>
</div>

<p-table
  [value]="rows"
  styleClass="audit-table"
  [tableStyle]="{ 'min-width': '70rem' }"
  [loading]="loading"
  [lazy]="true"
  (onLazyLoad)="onPageChange($event)"
  [paginator]="true"
  [rows]="pagination.pageSize"
  [totalRecords]="pagination.total"
  [first]="pagination.first"
  [rowsPerPageOptions]="[50, 100, 200, 500]"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 180px">التاريخ والوقت</th>
      <th>اسم المستخدم</th>
      <th style="width: 120px">النتيجة</th>
      <th style="width: 150px">عنوان IP</th>
      <th style="width: 120px">المستخدم</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-r>
    <tr>
      <td>
        <div class="date-cell">
          <div class="date">{{ r.atUtc | date : 'yyyy-MM-dd' }}</div>
          <div class="time">{{ r.atUtc | date : 'HH:mm:ss' }}</div>
        </div>
      </td>
      <td>
        <code class="username">{{ r.usernameTried || '—' }}</code>
      </td>
      <td>
        <p-tag
          [value]="getResultLabel(r.succeeded)"
          [severity]="getResultSeverity(r.succeeded)"
        ></p-tag>
      </td>
      <td>
        <span class="ip-address">{{ r.ipAddress || '—' }}</span>
      </td>
      <td>
        <span class="text-muted" *ngIf="!r.userId">—</span>
        <span *ngIf="r.userId" class="user-id">{{ r.userId }}</span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" style="text-align: center; padding: 2rem">
        <div style="color: #9ca3af">لا توجد محاولات دخول</div>
      </td>
    </tr>
  </ng-template>
</p-table>
